
<div class="cbb-wrap">

    
    <div class="cbb-banner">
        <div class="cbb-overlay"></div>
       <div class="cbb-txt">
            <h1>Certified Business Broker (CBB)</h1>
            <p>A Professional Certification Program On Business Brokerage</p>
        </div>
    </div>
    
    
    <div class="cbb-about">
        <div class="container">
            <div class="row">
                <div class="col-md-6">
                    <img src="../../../../../assets/images/certified-business-broker.jpg" alt="Certified Business Broker" class="img-fluid">
                </div>
                 <div class="col-md-6">
                    <h2>About <span>CBB Program</span></h2>
                    <p>Certified Business Broker (CBB) Program is a professional certification program tailored to fit the schedules of busy professionals / individuals with our intense Training Module. This program comprises of instructional syllabus covering the best practices, fundamentals and insights including interviews with industry experts. The program will help to raise your level of Business Brokerage Knowledge in order to increase your ability to work quickly and effectively. This Program will play an essential role in enhancing your skills and developing your abilities towards Broking.</p>
                </div>
            </div>
    
    
    <div class="row mt-4">
    <div class="col-md-12">
    <p class="f20">The Certified Business Broker Program includes:</p>
    <ul class="newlist">
    <li><b>A theoretical framework for Business Brokering</b> and the importance of good broking in the development of robust, efficient and innovative business deals</li>
    <li><b>Brokering skills development</b> in resource-mapping, relationship-management, partnering negotiations, facilitation and reviewing to reach final agreement</li>
    <li><b>Exploration of common brokering challenges</b></li>
    <li><b>Action planning for individual applications</b></li>
    </ul>
    </div>
    </div>
     </div>
    </div>
    
    
    
    <div class="five-strategy">
        <div class="container">
            <h2>5R'S <span>Strategy</span></h2>
            <ol class="five-list">
    <li>ReaIize and learn how to develop astrategy</li>
    <li>Register different techniques</li>
    <li>Recognize and discuss the leading practices</li>
    <li>Review the latest trends and developments</li>
    <li>Refine and rebuild your approach</li>
    
            </ol>
        </div>
    </div>
    
    
    
    
    <div class="cbb-advantages">
        <div class="container">
        <h2>CBB Program – <span>Advantages</span></h2>
    
    <p>Certified Business Broker (CBB) Program covers all basic Business Brokerage fundamentals and advanced techniques which are used to attain success in the highly prestigious, multi-crore Business Brokerage industry.</p>
    
    <p>Certified Business Broker training program is designed to train individuals to start their own Business Brokerage or to enhance the existing Brokerage Business and become a successful Entrepreneur.</p>
    
    <p><b>A Certified Business Broker is qualified to join BusinessEx broker network and will get an opportunity to become a member of Indian Business Brokers Association.</b></p>
    
    <p class="dark">Key Takeaways</p>
    <ul class="advantage">
    <li>Advance your Business Brokerage career</li>
    <li>Speak the Business Brokerage language</li>
    <li>Add the Certification from BusinessEx to Your Professional Career</li>
    <li>Practical experience to enhance Business Brokering skills & analytical capabilities with an  aptitude for working with diverse groups</li>
    </ul>
    
    </div>
    </div>
    
    
    
    
    
    <div class="training-module">
        <div class="container">
    <h2>Training <span>Module</span></h2>
    <p class="dark">A 4-day Training and Professional Development Program</p>
    <p>The Training Program would be an in-house extensive session led by our experienced team of consultants and sales professionals.The program has been designed to equip you with the appropriate tools and market knowledge to be successful. The first three and a half days would be for class-room training program. On the last day of training, we will have half day dedicated for an informal networking session followed by Cocktails and Dinner.</p>
    
    
    <p class="blue">TheTraining Program shall cover the following aspects but shall not be limited to below:</p>
    
    <p class="days">Day 1 </p>
    
    <p class="orange">Introduction</p>
    <ul>
    <li>About Franchise India: Group Companies & Our Products</li>
    <li>About Business Ex: Our Role, Mission & Vision</li>
    <li>About Biz Equity: Its Valuation Tools</li>
    </ul>
    
    <p class="orange">Understanding the Business Brokerage space</p>
    <ul>
    <li>The Eco System of Business Brokerage</li>
    <li>Indian Business Brokerage Industry</li>
    <li>Market Size</li>
    <li>Merger & Acquisition</li>
    <li>Opportunity with BusinessEx</li>
    <li>Need Gap Analysis</li>
    </ul>
    
    
    <p class="days">Day2</p>
    <p class="orange">Valuation & Deal Making</p>
    <ul>
    <li>Fundamentals of Business Brokerage</li>
    <li>Business Valuation & Pricing</li>
    <li>Understanding Financials: Fundamentals, Analysis</li>
    <li>Market Conditions & Market Price</li>
    <li>Knowing Competitive Advantage of Business Asset</li>
    <li>Setting Expectations</li>
    <li>Due Diligence</li>
    <li>Negotiation Techniques</li>
    <li>Deal Structuring & Transaction Management</li>
    <li>Deal Closing</li>
    <li>Legal Framework</li>
    </ul>
    
    <p class="days">Day3</p>
    <p class="orange">How to Run Successful Brokerage Business: Building Operational Knowledge</p>
    <ul>
    <li>Local Market Analysis</li>
    <li>Presentation to Business Seller</li>
    <li>Database Creation</li>
    <li>Building Quality Inventory</li>
    <li>Sales Process</li>
    <li>On boarding of Asset & Activation</li>
    <li>Strategic Marketing - Generating Buyer & Seller Leads</li>
    <li>Business Listings</li>
    <li>Leveraging Business Ex Marketing Platforms</li>
    <li>Leveraging Business Ex Infrastructure</li>
    <li>Buyers - Seller Business Contracts and Forms</li>
    <li>Training on Software & Business Brokerage Tools</li>
    </ul>
    
    <p class="days">Day4</p>
    <p class="orange">Action Plan & Workshop</p>
    <ul>
    <li>Building Goals</li>
    <li>Business Development Plan</li>
    <li>Case Studies/ Examples</li>
    <li>Daily Operations at Office</li>
    <li>Reporting Structure to HO</li>
    </ul>
    <p class="orange">Test & Certification</p>
    <ul>
    <li>Written Test: Assess the Qualifying Parameter for becoming 'CBB'</li>
    <li>Certificate Awarding & Facilitation</li>
    </ul>
    </div>
    </div>
    
    
    
    <div class="broking">
    <div class="container">
    <h2>Broking <span>Industry Insights</span></h2>
    <ul>
    <li>4.5 Trillion Dollar Industry Across the Globe</li>
    <li>1 Million+ Business Brokers in India</li>
    <li>5,000+ Businesses Listed Every Year for Buy/ Sale in India</li>
    <li>1 Billion Dollar Revenue Generated Annually via Business Broking</li>
    </ul>
    </div>
    </div>
    
    
    
    <div class="post-cbb">
    <div class="container">   
    <h2>Post <span>CBB Benefits</span></h2>
    <p>Once you become a Certified Business Broker (CBB), you can avail following benefits from  BusinessEx:</p>
    <ul>
    <li>Profitable revenue model (60:40)
    60% for CBB
    40% for BusinessEx</li>
    <li>Support for Lead Generation from BusinessEx</li>
    <li>Support for Digital Tools, Branding Tools & Infrastructure from BusinessEx</li>
    <li>Support from Local/Zonal Team of BusinessEx</li>
    <li>Networking Supportfordeal closure from BusinessEx</li>
    <li>Listing on BusinessEX website</li>
    </ul>
    </div>
    </div>
    
    
    
    <div class="buyer-seller">
    <div class="container">
    <p class="dark">A unique platform to Connect Buyers with Sellers of all industries at one place.</p>
    <h2>Buyer & <span>Seller Events</span></h2>
    
    <p class="dark">Need of Business Events</p>
    <p>"Business Meets" are organized to connect with potential buyers/sellers at the pre-scheduled event in order to close deals. The concept of Business meets is designed to build trust among the clients for customer retention. "Business Meets" help to conduct one to one meeting session between the CBB and decision maker. It helps the buyers and sellers to understand the procurement procedure in order to disclose the business deal in a transparent way.</p>
    
    <p class="dark">Objective of Events</p>
    <p>"Buyer & Seller Meets" offer a unique platform to connect Buyers with Sellers of all industries at one place. These B2B meetings between Buyers and Sellers will be organized by the CBBs & BusinessEx after completion of the training program.</p>
    
    <p>After completion of the program, below-mentioned events shall be conducted in a year:</p>
    
    <p class="dark">Exit Show:</p>
    <ol>
    <li>Seller focused event</li>
    <li>One day event</li>
    <li>Organized & managed by the CBB in his location</li>
    <li>Bi-Monthly</li>
    </ol>
    <p class="dark">Match-Making Event:</p>
    <ol>
    <li>Buyers & Sellers meet across industries</li>
    <li>Two days event</li>
    <li>Organized by BusinessEx in every zone</li>
    <li>Quarterly</li>
    </ol>
    <p class="dark">Annual CBB Meet:</p>
    <ol>
    <li>Asset sharing event</li>
    <li>One day national event</li>
    <li>Organized & managed by BusinessEx</li>
    </ol>
    </div>
    </div>
    
    
    
    <div class="eligibility">
    <div class="container">
    <h2><span>Eligibility</span></h2>
    <ul>
    <li>Financial Advisor</li>
    <li>CA/ ICWA / CS / CFA</li>
    <li>Insurance Agents/ Real Estate Brokers/ Loan Lender</li>
    <li>Management Graduate</li>
    <li>Business Brokerage Professional</li>
    <li>Other Business Professional Looking To Advance Their Business Brokerage Knowledge</li>
    </ul>
    <p class="dark"><b>Each CBB is independently owned & independently operated</b></p>
    </div>
    </div>
    
</div>
    
